import React from "react";
import { getEnviroment } from "../../../lib/utils.es6";
import { getAuthorizationToken, getUserFullname } from "../../../lib/access.es6";

class GeneratePolicy extends React.Component {


 render() {
    const source = "aspin";
    const environment = getEnviroment()
    const stagingBaseUrl = "https://ipp-coverlink-legal-medical.staging.aspin-inclusivity.com";
    const productionBaseUrl = "https://ipp-coverlink-legal-medical.inclusivity-aspin.com";
    const baseUrl = environment === "prod" ? productionBaseUrl : stagingBaseUrl;
    const bearerToken = getAuthorizationToken();
    const host_base_url = window.location.origin;
    const created_by = getUserFullname()
    const policyNumber = this.props.params && this.props.params.policy_number;
    const iframeSrc = `${baseUrl}/?source=${encodeURIComponent(source)}&host_base_url=${encodeURIComponent(host_base_url)}&created_by=${encodeURIComponent(created_by)}&bearer_token=${encodeURIComponent(bearerToken)}&environment=${encodeURIComponent(environment)}${policyNumber ? '&policy_number=' + encodeURIComponent(policyNumber) : ''}`;

    console.log('iframeSrc: ', iframeSrc)

    console.log("environment: ", environment);


    return (
      <>
        <section
          style={{
            background: "#FFFFFF",
            borderRadius: "8px",
            height: "auto",
            marginTop: "30px",
            marginBottom: "30px",
            width: "100%",
          }}
        >
          <iframe
            src={iframeSrc}
            width="100%"
            height="100%"
            style={{
              width: "100%",
              height: "calc(100vh - 100px)",
              border: "none",
            }}
            title="Insurance Quote"
          ></iframe>
        </section>
      </>
    );
  }
}

export default GeneratePolicy;
